import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ReferralVisitActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/ReferralVisit/ReferralVisitBrowser")
	}

	render() {
		return (
			<Activity 
				name="ReferralVisit"
				RenderedComponent={this.RenderedComponent}
				context="ReferralVisit"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ReferralVisitActivity)
